import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ExternalLoginType, User, UserSignUp } from '../../models/user';
import { LoginRequest } from './models/login.request';
import { IdentifierType, ParameterType, RegisterOption, RegisterParameter } from '../../models/client-configuration';
import dayjs from 'dayjs';
import { SignupResponse } from './models/signup.response';
import { Util } from 'src/app/util';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private readonly http = inject(HttpClient);

  verifyReCaptcha(captchaResponse: string): Observable<boolean> {
    const url = `${environment.apiUrl}/captcha/verify`;
    const params = { captchaResponse };

    return this.http.get<boolean>(url, { params });
  }

  recoverPassword(identifier: string): Observable<void> {
    const url = `${environment.apiUrl}/login/forgot`;
    const params = `identifier=${identifier}`;

    return this.http.post<void>(url, params, {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      }),
    });
  }

  login({ identifier, password, library, userType }: LoginRequest): Observable<User> {
    const url = `${environment.apiUrl}/login`;
    const params = [
      `userId=${identifier}`,
      `password=${encodeURIComponent(password)}`,
    ];

    if (library) {
      params.push(`library=${library}`);
    }

    if (userType !== undefined && userType >= 0) {
      params.push(`userType=${userType}`);
    }

    return this.http.post<User>(url, params.join('&'), {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      }),
    });
  }

  validateCode(code: string): Observable<void> {
    const url = `${environment.apiUrl}/code/validate`;

    return this.http.get<void>(url, { params: { code } });
  }

  getRutInfo(rut: string, multipleId: number): Observable<RegisterOption[]> {
    const url = `${environment.apiUrl}/login/get-info-rut`;
    const params = {
      rut,
      multipleId: multipleId.toString(),
    };

    return this.http.get<RegisterOption[]>(url, { params });
  }

  signup(userParams: RegisterParameter[], multipleId?: number, code?: string): Observable<SignupResponse> {
    const url = `${environment.apiUrl}/register`;
    const params = {};

    if (multipleId) {
      params['multipleId'] = multipleId;
    }

    if (code) {
      params['code'] = code;
    }

    return this.http.post<SignupResponse>(url, userParams, { params });
  }
}
